import {decorate, action, observable, computed, when} from 'mobx';
import {DateTime} from 'luxon';

export default class HotelStore{

  hotels = [];
  offers = [];
  connected = observable.box(false);
  validFrom = DateTime.now;
  numHotels = observable.box(0);

  isReconnectMode = false;
  lastGuidanceCode = '';
  //  'wss://cy40xkkcsj.execute-api.eu-central-1.amazonaws.com/stage';
  ws = null;
  rootStore;

  ltaUserCookie = null;

  constructor(rootStore){
    this.rootStore = rootStore;
    this.connect();
  }

  setHotels = (data) =>{
    // LTA response from BE. To test data add it here.
    // data = BE response
    // create or replace
    if (data.offers){
      this.hotels = [];
      data.offers.forEach((hotel, value) => {
        hotel._ltaId = data.id;
        hotel.offer.hibLink = hotel.offer.hibLink
            ? hotel.offer.hibLink.replace(/^https?:/, 'https:')
            : hotel.offer.hibLink;
        const oldHotelIndex = (this.hotels.findIndex((oldHotel) => {
          return oldHotel.bookingKey === hotel.bookingKey;
        }));
        if (oldHotelIndex !== -1){
          this.hotels[oldHotelIndex] = hotel;
        }else{
          this.hotels.push(hotel);
        }
      });

      if (isNaN(data.validFrom) || data.validFrom <= 0) {
        this.validFrom = new DateTime.local();
      } else {
        this.validFrom = new DateTime.fromSeconds(parseInt(data.validFrom));
      }

      const destSet = new Set();
      let count = 0;
      if (this.hotels){
        this.hotels.forEach((hotel, index) => {
          if (hotel.bookingKey !== ''){
            ++count;
            if (hotel.offer && hotel.offer.deviceTimes && hotel.offer.deviceTimes.outbound  && hotel.offer.deviceTimes.outbound.length > 0) {
              let outb = hotel.offer.deviceTimes.outbound[hotel.offer.deviceTimes.outbound.length-1];
              if (outb.arrival && outb.arrival.airport && outb.arrival.airport.code) {
                destSet.add(outb.arrival.airport.code);
              }
            }
          }
        });
      }

      const expiresSecs = data.validFrom + 3600 * 24 * 7;
      const expiresStr = new Date(expiresSecs * 1000).toUTCString();
      const midocoUser = data.midocoUser ? data.midocoUser : "0";
      const destArr = [...destSet];
      const cookieVals = {"destinations": destArr.join(), "userId": midocoUser, "expires" : expiresSecs};
      const Buffer = require("buffer").Buffer;
      this.ltaUserCookie = {"ltaUser": Buffer.from(JSON.stringify(cookieVals), "utf8").toString("base64"), "expires": expiresStr};

      this.hotels.forEach((hotel, index) => {
        // var timeOfVacancy = DateTime.now;
        let defVal = data.validFrom;
        if (!isNaN(hotel.offer.timeOfVacancy)){
          defVal = parseInt(hotel.offer.timeOfVacancy);
        }
        const validUntil  = DateTime.fromSeconds(defVal).plus({minutes: process.env.REACT_APP_VACANCY_VALID_UNTIL});

        if (validUntil < DateTime.local()){
          console.log("Vacancy Update Start");
          //this.updateHotel(index);
        }

      });
      this.numHotels = count;
      this.department = data.department

    }
  };


  setOffers = (data) =>{
    this.offers = data;
  };

  get hasHotels(){
    return this.hotels && this.hotels.length > 0;
  }

  connect = () => {
    const url = process.env.REACT_APP_WEBSOCKET_URL;

    this.isReconnectMode = this.ws !== null;

    this.ws = new WebSocket(url);

    this.ws.onopen = action(() => {
      this.connected.set(true);
      if (this.isReconnectMode){
        this.isReconnectMode = false;
        this.fetch(this.lastGuidanceCode);
      }
    });

    this.ws.onclose= action(() => {
      this.connected.set(false);
      this.connect();
      console.log('connection closed');
    });

    this.ws.onmessage = action((event) => {
      const data = JSON.parse(event.data);
        if (data.Error){
        console.log('Do error handling');
      }else{
          if (this.ws.lastMessage && this.ws.lastMessage.message === 'vacancy') {
            this.ws.lastMessage = null;
          } else {
            this.setHotels(data);
          }
      }
      this.rootStore.displayStore.isLoading.set(false);
    });
  };

  connectAsync = async () => {
  let connected = false;
    if (this.ws.readyState === this.ws.CLOSED){
      this.connect();
    }

    await when(
      () => this.connected.get() === true,
      () => {
        connected = true;
      }
    );

    return connected;
  };

  async updateHotel(which){
    if (await this.connectAsync()){
      let key = '';
      if (which === 'all') {
        key = 'all';
      } else {
        key = this.hotels[which].bookingKey;
      }

      // send vacancy request
      const message = {message:"vacancy", argument: {offerId: this.lastGuidanceCode, bookingKey: key}};
      this.ws.send(JSON.stringify(message));
    }
  }

  async fetch(guidanceCode){

    this.lastGuidanceCode = guidanceCode;
    this.hotels = [];

    if (await this.connectAsync()){
      let data = {
        message: "GET",
        argument: guidanceCode
      };
      try{
        await this.ws.send(JSON.stringify(data));
      }
      catch(e){
        console.log('Network error', e);
      }
      return true;

    }else{
      this.connect();
    }
    return false;
  }
}

decorate(HotelStore, {
  hotels: observable,
  offers: observable,
  connected: observable,
  validFrom: observable,
  numHotels: observable,
  ltaUserCookie: observable,
  setHotels: action,
  setOffers: action,
  hasHotels: computed
});
